module.exports = __webpack_public_path__ + "assets/img/25_354_big.4fbea768.jpg";